import { Circle, Icon, SquareProps } from '@chakra-ui/react'
import { HiCheck } from 'react-icons/hi'

interface RadioCircleProps extends SquareProps {
  questionCount: number
  answeredQuestionCount: number
  isActive: boolean
  onClick: () => void
}

export const CourseProgressStepCircle = (props: RadioCircleProps) => {
  const { isActive, questionCount, answeredQuestionCount } = props

  const isCompleted = questionCount > 0 && questionCount === answeredQuestionCount;

  return (
    <Circle
      size="8"
      cursor='pointer'
      onClick={props.onClick}
      bg={isCompleted ? 'var(--secondary)' : questionCount ? 'var(--orange)' : 'white'}
      borderWidth={isCompleted || questionCount ? '0' : '1px'}
      borderColor={'gray'}
    >
      {questionCount
        ? <Circle bg='white' size="5" >
          {isActive 
            ? <Circle bg='black' size="3" /> 
            : isCompleted && <Circle bg='var(--secondary)' size="6"><Icon as={HiCheck} color="fg.inverted" boxSize="5" /></Circle>
            }
        </Circle>
        : isActive && <Circle bg='black' size="3" />
      }
    </Circle>
  )
}
